import { action } from 'satcheljs';
import { getActivityFeedStore } from '../store/store';

export const dismissAllItems = action('ACTIVITY_FEED_DISMISS_ALL', () => ({
    itemIds: [...getActivityFeedStore().items.values()].map(item => item.id),
}));
